module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABSUlEQVQ4T93Uv07CUBTH8e8FggSKcXFkUgYHBxETjA64mLgwaBzlNTAu4qaL0fgGTk59DhM0LCYMOjqoUTCBaCn9YxpD5RpabxrjYMfe00/PSU9/gl++xKjnXpInwSYuKaX3CAwsdFHidljvg+41szg0AS0Ie+3C8XnSP57P22yv211iFMQid97BF3hFDZfDsM7uH2FlJ+uXVMomZ3t9T9kVRY5ksME+UI8EQl0scfAPwYdnWK1qVCsmjZs4MzmHk1rfmzTayN6TvTfQ0uA4YJiQ/lyw6GDAR/tLMFOCqQ25kUEbnk7DNiqkw9QcZJdHdx6sDnT0iCAxSEyDkH5zGbNewB2M3gvpMFuGybXwbHhvQftCEUzmIFOUR/7Oe6DR+gFUCIfAtseGg0J8BYA9bArDTJQDtkmeAVsIJpQDNo4uFsYErBKgUPQBZWuVFcJPknoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/images/service_mobile/8.png
// module id = bdMK
// module chunks = 1